import React, { useState, useEffect } from "react";
import ScrollableFeed from 'react-scrollable-feed'
// import './ScrollableFeed.css'

const Minutes = ({ participants, messages, setMessages }) => {
  const [text, setText] = useState("");
  // const [messages, setMessages] = useState([]);
  const [currentSpeaker, setSpeaker] = useState({
    name: "Add Participants",
    color: "#F87171",
  });
  const [speakerIndex, setSpeakerIndex] = useState(0);

  const handleSubmit = (event) => {
    var messageObj = {
      speaker: currentSpeaker,
      text: text,
      timestamp: new Date().getTime(),
    };
    messages.push(messageObj);
    setMessages([...messages]);
    setText("");
    event.preventDefault();
  };

  useEffect(() => {
    if (participants.length === 1) {
      setSpeaker(participants[0]);
    } else {
      setSpeaker(currentSpeaker);
    }
  }, [currentSpeaker, participants]);

  const handler = (event) => {
    if (event.keyCode === 9) {
      if (event.shiftKey) {
        console.log("shift + tab");
        if (speakerIndex <= 0) {
          setSpeakerIndex(participants.length - 1);
          setSpeaker(participants[participants.length - 1]);
        } else {
          setSpeakerIndex(speakerIndex - 1);
          setSpeaker(participants[speakerIndex - 1]);
        }
      } else {
        console.log("tab");
        if (speakerIndex + 1 >= participants.length) {
          setSpeakerIndex(0);
          setSpeaker(participants[0]);
        } else {
          setSpeakerIndex(speakerIndex + 1);
          setSpeaker(participants[speakerIndex + 1]);
        }
      }
    }
  };

  return (
    <div className="h-screen w-7/12 overflow-y-auto bg-gray-500 text-center flex-col shadow-xl">
      <h1 className="text-white">Minutes</h1>

      <div className="h-5/6 bg-white text-left mx-4 my-2 pl-2 rounded shadow-4xl break-words">
        <div className='h-full'>
          <ScrollableFeed>
          {messages.map((item, index) => (
            <div className="my-2" key={index}>
              <span className={"font-bold"} style={{color: item.speaker.color}}>
                {item.speaker.name}:{" "}
              </span>
              <span>{item.text}</span>
              <p className="text-xs text-gray-500 text-muted">
                {new Date(item.timestamp).toString()}
              </p> 
            </div>
          ))}
          </ScrollableFeed>
        </div>

      </div>

      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          if (e.keyCode === 9) e.preventDefault();
        }}
      >
        <div className="w-full flex flex-row justify-center">
          <div
            className={
              "text-center rounded text-white font-bold py-2 px-4 ml-4 flex-2" 
            }
            style={{backgroundColor: currentSpeaker.color}}
          >
            {currentSpeaker.name}
          </div>
          <input
            type="text"
            placeholder={
              participants.length !== 0
                ? "Enter what was said"
                : "Add participants"
            }
            disabled={participants.length !== 0 ? false : true}
            className={
              participants.length !== 0
                ? "mx-2 p-2 rounded flex-1"
                : "mx-2 p-2 rounded flex-1 bg-red-400 text-bold placeholder-white"
            }
            onKeyDown={handler}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mr-4 rounded inline-flex text-center shadow-xl flex-2"
            onClick={handleSubmit}
          >
            <span>Enter</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default Minutes;
